import { i18n } from '@/boot/i18n';

function getTokenStorage() {
  try {
    return localStorage.getItem('t-token');
  } catch (error) {
    return null;
  }
}

export default {
  token: typeof window !== 'undefined' ? getTokenStorage() || '' : '',
  error: null,
};

export function getDefaultError() {
  return {
    hasError: false,
    message: i18n.t('login.messages.invalid_access'),
  };
}